/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Creator commerce / storefront provider. Separate from SocialPlatformType — these are merch link-outs, not social profiles.
 * @export
 */
export const StorefrontPlatformType = {
    STREAMLABS: 'STREAMLABS',
    SHOPIFY: 'SHOPIFY',
    FOURTHWALL: 'FOURTHWALL',
    GUMROAD: 'GUMROAD',
    KOFI: 'KOFI',
    SPRING: 'SPRING',
    OTHER: 'OTHER'
} as const;
export type StorefrontPlatformType = typeof StorefrontPlatformType[keyof typeof StorefrontPlatformType];


export function instanceOfStorefrontPlatformType(value: any): boolean {
    for (const key in StorefrontPlatformType) {
        if (Object.prototype.hasOwnProperty.call(StorefrontPlatformType, key)) {
            if (StorefrontPlatformType[key as keyof typeof StorefrontPlatformType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StorefrontPlatformTypeFromJSON(json: any): StorefrontPlatformType {
    return StorefrontPlatformTypeFromJSONTyped(json, false);
}

export function StorefrontPlatformTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorefrontPlatformType {
    return json as StorefrontPlatformType;
}

export function StorefrontPlatformTypeToJSON(value?: StorefrontPlatformType | null): any {
    return value as any;
}

export function StorefrontPlatformTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): StorefrontPlatformType {
    return value as StorefrontPlatformType;
}

